import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-ellipsis whitespace-nowrap overflow-hidden flex items-center"
};
import Card from "./Card.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CardIncident',
  props: {
    rightSide: {
      type: Boolean
    },
    incident: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.rightSide ? (_openBlock(), _createBlock(Card, {
        key: 0,
        card: __props.incident.card,
        class: "mr-2"
      }, null, 8, ["card"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.incident.player.shortName) + " ", 1), !__props.rightSide ? (_openBlock(), _createBlock(Card, {
        key: 1,
        card: __props.incident.card,
        class: "ml-2"
      }, null, 8, ["card"])) : _createCommentVNode("", true)]);
    };
  }
});